var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPlaystore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 40,
    viewBox: "0 0 110 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_playstore",
    transform: "translate(-352 -457)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 110,
    height: 40,
    rx: 4,
    transform: "translate(352 457)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cont",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "txt",
    transform: "translate(-1 -2)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Play_Store",
    "data-name": "Play Store",
    transform: "translate(390 488)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Bold, Pretendard",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Play Store")), /*#__PURE__*/React.createElement("text", {
    id: "Download_on_the",
    "data-name": "Download on the",
    transform: "translate(390 473)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "Pretendard-Regular, Pretendard",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Download on the"))), /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(339.451 466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_202",
    "data-name": "\\uD328\\uC2A4 202",
    d: "M60.91,6.872c-2.3-1.3-6-3.386-11.732-6.625a1.372,1.372,0,0,0-1.215-.16L57.8,10.011Z",
    transform: "translate(-23.468 -0.012)",
    fill: "#32bbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_203",
    "data-name": "\\uD328\\uC2A4 203",
    d: "M24.494,1.93a1.389,1.389,0,0,0-.945,1.331V20.447a1.4,1.4,0,0,0,.736,1.241,1.424,1.424,0,0,0,.209.09l9.837-9.924Z",
    transform: "translate(0 -1.855)",
    fill: "#32bbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_204",
    "data-name": "\\uD328\\uC2A4 204",
    d: "M57.793,255.98,47.956,265.9a1.357,1.357,0,0,0,1.216-.16c5.56-3.141,9.214-5.2,11.544-6.514l.191-.108Z",
    transform: "translate(-23.462 -245.981)",
    fill: "#32bbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_205",
    "data-name": "\\uD328\\uC2A4 205",
    d: "M23.549,255.98v8.593a1.4,1.4,0,0,0,.736,1.241,1.421,1.421,0,0,0,.209.09l9.837-9.924Z",
    transform: "translate(0 -245.981)",
    fill: "#2c9fd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_206",
    "data-name": "\\uD328\\uC2A4 206",
    d: "M43.986.236a1.376,1.376,0,0,0-1.425-.07l9.9,9.984,3.261-3.29C53.415,5.561,49.719,3.474,43.986.236Z",
    transform: "translate(-18.276)",
    fill: "#29cc5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_207",
    "data-name": "\\uD328\\uC2A4 207",
    d: "M52.457,252.126l-9.9,9.984a1.367,1.367,0,0,0,1.425-.07c5.56-3.141,9.214-5.2,11.544-6.514l.191-.108Z",
    transform: "translate(-18.276 -242.277)",
    fill: "#d93f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_208",
    "data-name": "\\uD328\\uC2A4 208",
    d: "M301.82,176.1a1.394,1.394,0,0,0-.71-1.223l-3.588-2.024L294.3,176.1l3.221,3.25c2.676-1.516,3.585-2.027,3.585-2.027A1.394,1.394,0,0,0,301.82,176.1Z",
    transform: "translate(-260.271 -166.105)",
    fill: "#ffd500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_209",
    "data-name": "\\uD328\\uC2A4 209",
    d: "M301.11,257.2a1.394,1.394,0,0,0,.71-1.223H294.3l3.221,3.25C300.2,257.714,301.11,257.2,301.11,257.2Z",
    transform: "translate(-260.271 -245.981)",
    fill: "#fa0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPlaystore);
export default __webpack_public_path__ + "static/media/logo_playstore.61123aedfadedfc85f86b9275d2aa123.svg";
export { ForwardRef as ReactComponent };